module.exports = __webpack_public_path__ + "static/How-AI-Is-Making-Smart-Homes-More-Energy-Efficient-clean-771784db5b3149a2f913b4d2719678fc.png";